module.exports = __webpack_public_path__ + "static/media/help-icon2.dfe728a1.svg";